import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BlueprintSummaryComponent } from 'src/app/main/service/blueprint-summary/blueprint-summary.component';
import { Capability, CapabilityType } from 'src/app/models/service/capability';
import { DynamicFormModel } from 'src/app/models/service/dynamic-form-model';
import { InstallationSchemaPropertyType } from 'src/app/models/service/installation-schema-property-type';

@Component({
    selector: 'app-view-service-definition-version-details',
    templateUrl: './view-service-definition-version-details.component.html',
    styleUrls: ['./view-service-definition-version-details.component.scss'],
    standalone: false
})
export class ViewServiceDefinitionVersionDetailsComponent implements OnInit {
  dynamicFormModels: DynamicFormModel;
  serviceName: string;
  blueprintName: string;
  region: string;
  sysgen: any;
  capabilities: Capability[];
  CapabilityType = CapabilityType;
  includedCapabilities: Capability[];
  optionalCapabilities: Capability[];
  InstallationSchemaPropertyType = InstallationSchemaPropertyType;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private matDialogRef: MatDialogRef<BlueprintSummaryComponent>) { }
  ngOnInit(): void {
    this.dynamicFormModels = this.data.dynamicForm;
    this.serviceName = this.data.serviceName;
    this.blueprintName = this.data.blueprintName;
    this.region =  this.data.region;
    this.sysgen = (this.data.sysgen === 'sysgen' ? true : false);
    this.capabilities = this.data.capabilities;
    this.includedCapabilities = this.capabilities;
     // this.optionalCapabilities = this.capabilities?.filter(item => item.required === CapabilityType.OPTIONAL);
  }

  closeDialog(): void {
    this.matDialogRef.close();
  }

  typeOfPropertyValue(value): boolean {
    return typeof value == 'object' || value === '';
  }

}
